import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Logout.css';

function Logout({ setIsAuthenticated, setUserId, setMessage }) {
  const navigate = useNavigate();
  const [nickname, setNickname] = useState('User'); // Default to "User" until fetched

  // Fetch the user's nickname
  useEffect(() => {
    const fetchUserNickname = async () => {
      try {
        const response = await fetch('/api/me', {
          credentials: 'include',
        });
        const data = await response.json();
        if (data.success) {
          // Fetch user details using the userId
          const userResponse = await fetch(`/api/user/${data.userId}`, {
            credentials: 'include',
          });
          const userData = await userResponse.json();
          if (userData.success) {
            setNickname(userData.user.nickname);
          }
        }
      } catch (error) {
        console.error('Error fetching user nickname:', error);
      }
    };

    fetchUserNickname();
  }, []);

  const handleLogout = () => {
    // Clear authentication state
    setIsAuthenticated(false);
    setUserId(null);

    // Set a flag to indicate the user has logged out
    localStorage.setItem('justLoggedOut', 'true');

    // Clear the token cookie client-side as a fallback
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure; SameSite=Lax';

    // Clear the token cookie by making a request to the logout endpoint
    fetch('/api/logout', {
      method: 'POST',
      credentials: 'include',
    })
      .then(() => {
        setMessage('Logged out successfully!');
        // Redirect to login page after logout
        navigate('/login', { replace: true }); // Use replace to prevent going back to logout page
      })
      .catch((error) => {
        console.error('Error during logout:', error);
        setMessage('Error logging out');
        navigate('/login', { replace: true });
      });
  };

  const handleCancel = () => {
    // Redirect back to the chat page
    navigate('/chat');
  };

  return (
    <div className="logout-container">
      <span className="decorative-icon chat-bubble">💬</span>
      <h2>
        Are you sure you want to log out, <span className="highlight">{nickname}?</span>
      </h2>
      <div className="logout-buttons">
        <button className="confirm-btn" onClick={handleLogout}>
          Yes
        </button>
        <button className="cancel-btn" onClick={handleCancel}>
          No
        </button>
      </div>
    </div>
  );
}

export default Logout;